import React from 'react';
import { REPORT } from '../print/PrintAtoms';
import { PORTFOLIO_TOKENS } from './tokens';

export type SortKey = 'rank' | 'mw' | 'resolve' | 'acres' | 'grade';

interface Props {
  rowCount: number;
  totalCount: number;
  active: SortKey;
  onChange: (key: SortKey) => void;
}

interface BtnProps {
  label: string;
  arrow: '▼' | '▲';
  active: boolean;
  onClick: () => void;
}

const SortBtn: React.FC<BtnProps> = ({ label, arrow, active, onClick }) => (
  <button
    onClick={onClick}
    style={{
      fontFamily: PORTFOLIO_TOKENS.mono,
      fontSize: 10,
      fontWeight: active ? 600 : 500,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: active ? REPORT.white : REPORT.secondary,
      background: active ? REPORT.heading : 'transparent',
      border: `1px solid ${active ? REPORT.heading : PORTFOLIO_TOKENS.ruleMid}`,
      padding: '5px 10px',
      cursor: 'pointer',
      borderRadius: 3,
      transition: 'all 0.15s ease',
    }}
  >
    {label}<span style={{ marginLeft: 3, opacity: 0.7 }}>{arrow}</span>
  </button>
);

export const PortfolioSortRail: React.FC<Props> = ({ rowCount, totalCount, active, onChange }) => (
  <div style={{
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    padding: '12px 0',
    borderTop: `1px solid ${PORTFOLIO_TOKENS.ruleHard}`,
    borderBottom: `1px solid ${REPORT.rule}`,
    marginBottom: 0,
  }}>
    <div style={{
      fontFamily: PORTFOLIO_TOKENS.mono,
      fontSize: 10,
      fontWeight: 600,
      letterSpacing: '0.12em',
      textTransform: 'uppercase',
      color: REPORT.secondary,
    }}>
      Showing <strong style={{ color: REPORT.heading, fontWeight: 700 }}>{rowCount} of {totalCount}</strong> · Top of List
    </div>
    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
      <span style={{
        fontFamily: PORTFOLIO_TOKENS.mono,
        fontSize: 9.5,
        color: REPORT.tertiary,
        letterSpacing: '0.10em',
        textTransform: 'uppercase',
        marginRight: 8,
      }}>Sort</span>
      <SortBtn label="Atwater Priority" arrow="▲" active={active === 'rank'} onClick={() => onChange('rank')} />
      <SortBtn label="Pipeline MW" arrow="▼" active={active === 'mw'} onClick={() => onChange('mw')} />
      <SortBtn label="Resolve Count" arrow="▲" active={active === 'resolve'} onClick={() => onChange('resolve')} />
      <SortBtn label="Acres" arrow="▼" active={active === 'acres'} onClick={() => onChange('acres')} />
      <SortBtn label="Grade" arrow="▼" active={active === 'grade'} onClick={() => onChange('grade')} />
    </div>
  </div>
);
